import { render, staticRenderFns } from "./ChatIdModal.vue?vue&type=template&id=7c942702"
import script from "./ChatIdModal.vue?vue&type=script&lang=js"
export * from "./ChatIdModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports